import React, { Component } from 'react'
import { connect } from "react-redux";
import { Col, Container, Image } from 'react-bootstrap';
import "../../ecom/ecom.scss";
import Piechart from '../../../shared/components/charts/Piechart';
import Linegraph_sparkline from '../../../shared/components/charts/Linegraph_sparkline';
import { ChartCard } from '../../../shared/components/cards/chartcard/chartcard'
import { Carousel } from '../../../shared/components/carousel/carousel';
import '../../../shared/components/cards/card.scss'
import IconWebsite from '../../../../assets/images/icons/websiteIcon';
import { DailydataDropdown } from '../../../shared/components/dropdown/dailydatadropdown';
import { Link } from 'react-router-dom'
import Sunbrust_chart from '../../../shared/components/charts/Sunbrust_chart';
import BulletPiechart from '../../../shared/components/charts/BulltePieChart';
import DataTable from '../../../shared/components/Datatable/DataTable';
import { API_URL } from '../../../../../constants/constants';
import DatePicker from '../../../shared/components/datepicker/datepicker';
import IconPdf from '../../../../assets/images/icons/pdfIcon';
import HeatMap from '../../../shared/components/charts/HeatMap';
import StickyLogo from '../../../../assets/images/icons/icon.png'
import { Loader } from '../../../shared/components/loader/loader';
import ECOMIndiaMap from '../../../shared/components/map/indiamap/ecomindianmap';
import Wrapper from '../../../helpers/wrapper';
import ChartExport from '../../../shared/components/export/ChartExport';
import { NoDataAvailable } from '../../../shared/components/loader/noDataAvailable';
import '../../../layout/pageheader/pageheader.scss'
import PageHeader from '../../../../../components/layout/pageHeader';



export class Traffic extends Component {

    constructor(props) {
        super(props);
        this.state = {

            trafficeChannel: 'Overall',

            indiaMapData: { "data": [{ zone_id: 1, center: "77.16659704, 31.10002545", north_corner: "73.729184, 36.895584", south_corner: "83.045590, 23.924173", zone: "NORTH", nsv: 30571451.0, target_nsv: 43594040.14, nsv_achieved: 70.13, ats: 2977.93, score: 39.0, nsv_mix: 12.47 }, { zone_id: 4, center: "79.0193, 18.1124", north_corner: "77.5634765625, 18.437924653474408", south_corner: "79.82048034667969, 11.88146190297441", zone: "APTS", nsv: 35146498.0, target_nsv: 65002442.56, nsv_achieved: 54.07, ats: 3334.27, score: 39.0, nsv_mix: 14.33 }, { zone_id: 5, center: "86.41998572, 23.80039349", north_corner: "80.57373046875, 30.486550842588485", south_corner: "92.94433593749999, 22.14670778001263", zone: "EAST", nsv: 42378073.0, target_nsv: 72420065.4, nsv_achieved: 58.52, ats: 2849.52, score: 37.0, nsv_mix: 17.28 }, { zone_id: 3, center: "77.5946, 12.9716", north_corner: "73.71826171874999, 15.728813770533966", south_corner: "77.65583038330078, 11.953769241237044", zone: "SOUTH", nsv: 42053827.0, target_nsv: 78553853.26, nsv_achieved: 53.54, ats: 3194.37, score: 34.0, nsv_mix: 17.15 }, { zone_id: 2, center: "72.8777, 19.0760", north_corner: "68.66180419921875, 23.792884472869158", south_corner: "80.79757690429686, 19.468534402813017", zone: "WEST", nsv: 95052319.0, target_nsv: 138137016.89, nsv_achieved: 68.81, ats: 2923.7, score: 38.0, nsv_mix: 38.76 }] },

            is_audience_demographic_loaded: false,
            audience_graphic: [{ country: "Male", "units": 500, "pie": [{ "value": 250, "title": "Cat #1" }, { "value": 150, "title": "Cat #2" }, { "value": 100, "title": "Cat #3" }] }, { country: "Female", "units": 450, "pie": [{ "value": 180, "title": "Cat #1" }, { "value": 130, "title": "Cat #2" }, { "value": 190, "title": "Cat #3" }] }],
            dropdown_options: [{ "value": "traffic_channels", "label": "Traffic Channels" }, { "value": "product", "label": "Product" }],
            // trafficpievalue: [{ "name": "Social", "value": 30 }, { "name": "Direct", "value": 30 }, { "name": "Website", "value": 50 }, { "name": "Email", "value": 40 }, { "name": "Organic", "value": 60 }],
            trafficpievalue: [],
            bargraphsession: [{ "name": "Jan", "points": 100 }, { "name": "Feb", "points": 200 }, { "name": "march", "points": 110 }, { "name": "April", "points": 100 }, { "name": "May", "points": 100 }, { "name": "June", "points": 100 }, { "name": "July", "points": 100 }, { "name": "Aug", "points": 100 }, { "name": "Sep", "points": 130 }, { "name": "Oct", "points": 140 }, { "name": "Nov", "points": 200 }, { "name": "Dec", "points": 180 }],
            linesparkgraph: [{ "date": "2012-07-27", "value": 13 }, { "date": "2012-07-28", "value": 10 }, { "date": "2012-07-29", "value": 15 }, { "date": "2012-07-30", "value": 15 }, { "date": "2012-07-31", "value": 15 }, { "date": "2012-08-01", "value": 15 }, { "date": "2012-08-02", "value": 15 }, { "date": "2012-08-03", "value": 19 }, { "date": "2012-08-04", "value": 16 }, { "date": "2012-08-05", "value": 15 }, { "date": "2012-08-06", "value": 19 }, { "date": "2012-08-07", "value": 17 }, { "date": "2012-08-08", "value": 18 }],
            scroll: '',
            funnelgraph: [{ "name": "Sessions with Category Page Views", "value": 150 }, { "name": "Sessions with Product detail page views", "value": 300 }, { "name": "Sessions with Add to Cart", "value": 150 }, { "name": "Sessions with visit to Checkout Page", "value": 180 }, { "name": "Sessions with Visit to Address Page", "value": 50 }, { "name": "Sessions with Visit to Payment Page", "value": 20 }, { "name": "Sessions with Purchase", "value": 10 }],
            treegraph: [{ "name": "Home", "children": [{ "name": "Kitchen", "value": 150 }] }, { "name": "Men", "children": [{ "name": "Casual", "value": 350 }, { "name": "Western", "value": 400 }] }, { "name": "Women", "children": [{ "name": "Western", "children": [{ "name": "Jeans", "value": 240 }] }, { "name": "Casual", "value": 100 }] }, { "name": "Lifestyle", "value": 180 }],
            clustergraph: [{ "network": "Facebook", "MAU": 22552 }, { "network": "Google+", "MAU": 20552 }, { "network": "Instagram", "MAU": 13552 }, { "network": "Pinterest", "MAU": 19552 }, { "network": "Reddit", "MAU": 20552 }],
            activity: [{ "hour": "12pm", "weekday": "Sun", "value": 2990 }, { "hour": "1am", "weekday": "Sun", "value": 2520 }, { "hour": "2am", "weekday": "Sun", "value": 2334 }, { "hour": "3am", "weekday": "Sun", "value": 2230 }, { "hour": "4am", "weekday": "Sun", "value": 2325 }, { "hour": "5am", "weekday": "Sun", "value": 2019 }, { "hour": "6am", "weekday": "Sun", "value": 2128 }, { "hour": "7am", "weekday": "Sun", "value": 2246 }, { "hour": "8am", "weekday": "Sun", "value": 2421 }, { "hour": "9am", "weekday": "Sun", "value": 2788 }, { "hour": "10am", "weekday": "Sun", "value": 2959 }, { "hour": "11am", "weekday": "Sun", "value": 3018 }, { "hour": "12am", "weekday": "Sun", "value": 3154 }, { "hour": "1pm", "weekday": "Sun", "value": 3172 }, { "hour": "2pm", "weekday": "Sun", "value": 3368 }, { "hour": "3pm", "weekday": "Sun", "value": 3464 }, { "hour": "4pm", "weekday": "Sun", "value": 3746 }, { "hour": "5pm", "weekday": "Sun", "value": 3656 }, { "hour": "6pm", "weekday": "Sun", "value": 3336 }, { "hour": "7pm", "weekday": "Sun", "value": 3292 }, { "hour": "8pm", "weekday": "Sun", "value": 3269 }, { "hour": "9pm", "weekday": "Sun", "value": 3300 }, { "hour": "10pm", "weekday": "Sun", "value": 3403 }, { "hour": "11pm", "weekday": "Sun", "value": 3323 }, { "hour": "12pm", "weekday": "Mon", "value": 3346 }, { "hour": "1am", "weekday": "Mon", "value": 2725 }, { "hour": "2am", "weekday": "Mon", "value": 3052 }, { "hour": "3am", "weekday": "Mon", "value": 3876 }, { "hour": "4am", "weekday": "Mon", "value": 4453 }, { "hour": "5am", "weekday": "Mon", "value": 3972 }, { "hour": "6am", "weekday": "Mon", "value": 4644 }, { "hour": "7am", "weekday": "Mon", "value": 5715 }, { "hour": "8am", "weekday": "Mon", "value": 7080 }, { "hour": "9am", "weekday": "Mon", "value": 8022 }, { "hour": "10am", "weekday": "Mon", "value": 8446 }, { "hour": "11am", "weekday": "Mon", "value": 9313 }, { "hour": "12am", "weekday": "Mon", "value": 9011 }, { "hour": "1pm", "weekday": "Mon", "value": 8508 }, { "hour": "2pm", "weekday": "Mon", "value": 8515 }, { "hour": "3pm", "weekday": "Mon", "value": 8399 }, { "hour": "4pm", "weekday": "Mon", "value": 8649 }, { "hour": "5pm", "weekday": "Mon", "value": 7869 }, { "hour": "6pm", "weekday": "Mon", "value": 6933 }, { "hour": "7pm", "weekday": "Mon", "value": 5969 }, { "hour": "8pm", "weekday": "Mon", "value": 5552 }, { "hour": "9pm", "weekday": "Mon", "value": 5434 }, { "hour": "10pm", "weekday": "Mon", "value": 5070 }, { "hour": "11pm", "weekday": "Mon", "value": 4851 }, { "hour": "12pm", "weekday": "Tue", "value": 4468 }, { "hour": "1am", "weekday": "Tue", "value": 3306 }, { "hour": "2am", "weekday": "Tue", "value": 3906 }, { "hour": "3am", "weekday": "Tue", "value": 4413 }, { "hour": "4am", "weekday": "Tue", "value": 4726 }, { "hour": "5am", "weekday": "Tue", "value": 4584 }, { "hour": "6am", "weekday": "Tue", "value": 5717 }, { "hour": "7am", "weekday": "Tue", "value": 6504 }, { "hour": "8am", "weekday": "Tue", "value": 8104 }, { "hour": "9am", "weekday": "Tue", "value": 8813 }, { "hour": "10am", "weekday": "Tue", "value": 9278 }, { "hour": "11am", "weekday": "Tue", "value": 10425 }, { "hour": "12am", "weekday": "Tue", "value": 10137 }, { "hour": "1pm", "weekday": "Tue", "value": 9290 }, { "hour": "2pm", "weekday": "Tue", "value": 9255 }, { "hour": "3pm", "weekday": "Tue", "value": 9614 }, { "hour": "4pm", "weekday": "Tue", "value": 9713 }, { "hour": "5pm", "weekday": "Tue", "value": 9667 }, { "hour": "6pm", "weekday": "Tue", "value": 8774 }, { "hour": "7pm", "weekday": "Tue", "value": 8649 }, { "hour": "8pm", "weekday": "Tue", "value": 9937 }, { "hour": "9pm", "weekday": "Tue", "value": 10286 }, { "hour": "10pm", "weekday": "Tue", "value": 9175 }, { "hour": "11pm", "weekday": "Tue", "value": 8581 }, { "hour": "12pm", "weekday": "Wed", "value": 8145 }, { "hour": "1am", "weekday": "Wed", "value": 7177 }, { "hour": "2am", "weekday": "Wed", "value": 5657 }, { "hour": "3am", "weekday": "Wed", "value": 6802 }, { "hour": "4am", "weekday": "Wed", "value": 8159 }, { "hour": "5am", "weekday": "Wed", "value": 8449 }, { "hour": "6am", "weekday": "Wed", "value": 9453 }, { "hour": "7am", "weekday": "Wed", "value": 9947 }, { "hour": "8am", "weekday": "Wed", "value": 11471 }, { "hour": "9am", "weekday": "Wed", "value": 12492 }, { "hour": "10am", "weekday": "Wed", "value": 9388 }, { "hour": "11am", "weekday": "Wed", "value": 9928 }, { "hour": "12am", "weekday": "Wed", "value": 9644 }, { "hour": "1pm", "weekday": "Wed", "value": 9034 }, { "hour": "2pm", "weekday": "Wed", "value": 8964 }, { "hour": "3pm", "weekday": "Wed", "value": 9069 }, { "hour": "4pm", "weekday": "Wed", "value": 8898 }, { "hour": "5pm", "weekday": "Wed", "value": 8322 }, { "hour": "6pm", "weekday": "Wed", "value": 6909 }, { "hour": "7pm", "weekday": "Wed", "value": 5810 }, { "hour": "8pm", "weekday": "Wed", "value": 5151 }, { "hour": "9pm", "weekday": "Wed", "value": 4911 }, { "hour": "10pm", "weekday": "Wed", "value": 4487 }, { "hour": "11pm", "weekday": "Wed", "value": 4118 }, { "hour": "12pm", "weekday": "Thu", "value": 3689 }, { "hour": "1am", "weekday": "Thu", "value": 3081 }, { "hour": "2am", "weekday": "Thu", "value": 6525 }, { "hour": "3am", "weekday": "Thu", "value": 6228 }, { "hour": "4am", "weekday": "Thu", "value": 6917 }, { "hour": "5am", "weekday": "Thu", "value": 6568 }, { "hour": "6am", "weekday": "Thu", "value": 6405 }, { "hour": "7am", "weekday": "Thu", "value": 8106 }, { "hour": "8am", "weekday": "Thu", "value": 8542 }, { "hour": "9am", "weekday": "Thu", "value": 8501 }, { "hour": "10am", "weekday": "Thu", "value": 8802 }, { "hour": "11am", "weekday": "Thu", "value": 9420 }, { "hour": "12am", "weekday": "Thu", "value": 8966 }, { "hour": "1pm", "weekday": "Thu", "value": 8135 }, { "hour": "2pm", "weekday": "Thu", "value": 8224 }, { "hour": "3pm", "weekday": "Thu", "value": 8387 }, { "hour": "4pm", "weekday": "Thu", "value": 8218 }, { "hour": "5pm", "weekday": "Thu", "value": 7641 }, { "hour": "6pm", "weekday": "Thu", "value": 6469 }, { "hour": "7pm", "weekday": "Thu", "value": 5441 }, { "hour": "8pm", "weekday": "Thu", "value": 4952 }, { "hour": "9pm", "weekday": "Thu", "value": 4643 }, { "hour": "10pm", "weekday": "Thu", "value": 4393 }, { "hour": "11pm", "weekday": "Thu", "value": 4017 }, { "hour": "12pm", "weekday": "Fri", "value": 4022 }, { "hour": "1am", "weekday": "Fri", "value": 3063 }, { "hour": "2am", "weekday": "Fri", "value": 3638 }, { "hour": "3am", "weekday": "Fri", "value": 3968 }, { "hour": "4am", "weekday": "Fri", "value": 4070 }, { "hour": "5am", "weekday": "Fri", "value": 4019 }, { "hour": "6am", "weekday": "Fri", "value": 4548 }, { "hour": "7am", "weekday": "Fri", "value": 5465 }, { "hour": "8am", "weekday": "Fri", "value": 6909 }, { "hour": "9am", "weekday": "Fri", "value": 7706 }, { "hour": "10am", "weekday": "Fri", "value": 7867 }, { "hour": "11am", "weekday": "Fri", "value": 8615 }, { "hour": "12am", "weekday": "Fri", "value": 8218 }, { "hour": "1pm", "weekday": "Fri", "value": 7604 }, { "hour": "2pm", "weekday": "Fri", "value": 7429 }, { "hour": "3pm", "weekday": "Fri", "value": 7488 }, { "hour": "4pm", "weekday": "Fri", "value": 7493 }, { "hour": "5pm", "weekday": "Fri", "value": 6998 }, { "hour": "6pm", "weekday": "Fri", "value": 5941 }, { "hour": "7pm", "weekday": "Fri", "value": 5068 }, { "hour": "8pm", "weekday": "Fri", "value": 4636 }, { "hour": "9pm", "weekday": "Fri", "value": 4241 }, { "hour": "10pm", "weekday": "Fri", "value": 3858 }, { "hour": "11pm", "weekday": "Fri", "value": 3833 }, { "hour": "12pm", "weekday": "Sat", "value": 3503 }, { "hour": "1am", "weekday": "Sat", "value": 2842 }, { "hour": "2am", "weekday": "Sat", "value": 2808 }, { "hour": "3am", "weekday": "Sat", "value": 2399 }, { "hour": "4am", "weekday": "Sat", "value": 2280 }, { "hour": "5am", "weekday": "Sat", "value": 2139 }, { "hour": "6am", "weekday": "Sat", "value": 2527 }, { "hour": "7am", "weekday": "Sat", "value": 2940 }, { "hour": "8am", "weekday": "Sat", "value": 3066 }, { "hour": "9am", "weekday": "Sat", "value": 3494 }, { "hour": "10am", "weekday": "Sat", "value": 3287 }, { "hour": "11am", "weekday": "Sat", "value": 3416 }, { "hour": "12am", "weekday": "Sat", "value": 3432 }, { "hour": "1pm", "weekday": "Sat", "value": 3523 }, { "hour": "2pm", "weekday": "Sat", "value": 3542 }, { "hour": "3pm", "weekday": "Sat", "value": 3347 }, { "hour": "4pm", "weekday": "Sat", "value": 3292 }, { "hour": "5pm", "weekday": "Sat", "value": 3416 }, { "hour": "6pm", "weekday": "Sat", "value": 3131 }, { "hour": "7pm", "weekday": "Sat", "value": 3057 }, { "hour": "8pm", "weekday": "Sat", "value": 3227 }, { "hour": "9pm", "weekday": "Sat", "value": 3060 }, { "hour": "10pm", "weekday": "Sat", "value": 2855 }, { "hour": "11pm", "weekday": "Sat", "value": 2625 }],
            age_bracket: "",
            is_day_time_traffic_loaded: false,
            bubblechart: [{ "hour": "12pm", "weekday": "Sun", "value": 2990 }, { "hour": "1pm", "weekday": "Sun", "value": 2990 }, { "hour": "2pm", "weekday": "Sun", "value": 1990 }, { "hour": "3pm", "weekday": "Sun", "value": 990 }, { "hour": "4pm", "weekday": "Sun", "value": 2000 }, { "hour": "5pm", "weekday": "Sun", "value": 7890 }, { "hour": "6pm", "weekday": "Sun", "value": 1290 }, { "hour": "7pm", "weekday": "Sun", "value": 1090 }, { "hour": "8pm", "weekday": "Sun", "value": 2990 }, { "hour": "9pm", "weekday": "Sun", "value": 2990 }, { "hour": "10pm", "weekday": "Sun", "value": 2990 }, { "hour": "11pm", "weekday": "Sun", "value": 2990 }, { "hour": "12pm", "weekday": "Sun", "value": 2990 }, { "hour": "1am", "weekday": "Sun", "value": 1890 }, { "hour": "2am", "weekday": "Sun", "value": 1990 }, { "hour": "3am", "weekday": "Sun", "value": 1000 }, { "hour": "4am", "weekday": "Sun", "value": 2100 }, { "hour": "5am", "weekday": "Sun", "value": 2990 }, { "hour": "6am", "weekday": "Sun", "value": 2100 }, { "hour": "7am", "weekday": "Sun", "value": 2990 }, { "hour": "8am", "weekday": "Sun", "value": 1200 }, { "hour": "9am", "weekday": "Sun", "value": 900 }, { "hour": "10am", "weekday": "Sun", "value": 2000 }, { "hour": "11am", "weekday": "Sun", "value": 1100 }, { "hour": "12am", "weekday": "Sun", "value": 2990 }, { "hour": "12pm", "weekday": "Mon", "value": 2990 }, { "hour": "1pm", "weekday": "Mon", "value": 2990 }, { "hour": "2pm", "weekday": "Mon", "value": 1990 }, { "hour": "3pm", "weekday": "Mon", "value": 990 }, { "hour": "4pm", "weekday": "Mon", "value": 2000 }, { "hour": "5pm", "weekday": "Mon", "value": 7890 }, { "hour": "6pm", "weekday": "Mon", "value": 1290 }, { "hour": "7pm", "weekday": "Mon", "value": 1090 }, { "hour": "8pm", "weekday": "Mon", "value": 2990 }, { "hour": "9pm", "weekday": "Mon", "value": 2990 }, { "hour": "10pm", "weekday": "Mon", "value": 2990 }, { "hour": "11pm", "weekday": "Mon", "value": 2990 }, { "hour": "12pm", "weekday": "Mon", "value": 2990 }, { "hour": "1am", "weekday": "Mon", "value": 1890 }, { "hour": "2am", "weekday": "Mon", "value": 1990 }, { "hour": "3am", "weekday": "Mon", "value": 1000 }, { "hour": "4am", "weekday": "Mon", "value": 2100 }, { "hour": "5am", "weekday": "Mon", "value": 2990 }, { "hour": "6am", "weekday": "Mon", "value": 2100 }, { "hour": "7am", "weekday": "Mon", "value": 2990 }, { "hour": "8am", "weekday": "Mon", "value": 1200 }, { "hour": "9am", "weekday": "Mon", "value": 900 }, { "hour": "10am", "weekday": "Mon", "value": 2000 }, { "hour": "11am", "weekday": "Mon", "value": 1100 }, { "hour": "12am", "weekday": "Mon", "value": 2990 }, { "hour": "12pm", "weekday": "Wed", "value": 2990 }, { "hour": "1pm", "weekday": "Wed", "value": 2990 }, { "hour": "2pm", "weekday": "Wed", "value": 1990 }, { "hour": "3pm", "weekday": "Wed", "value": 990 }, { "hour": "4pm", "weekday": "Wed", "value": 2000 }, { "hour": "5pm", "weekday": "Wed", "value": 7890 }, { "hour": "6pm", "weekday": "Wed", "value": 1290 }, { "hour": "7pm", "weekday": "Wed", "value": 1090 }, { "hour": "8pm", "weekday": "Wed", "value": 2990 }, { "hour": "9pm", "weekday": "Wed", "value": 2990 }, { "hour": "10pm", "weekday": "Wed", "value": 2990 }, { "hour": "11pm", "weekday": "Wed", "value": 2990 }, { "hour": "12pm", "weekday": "Wed", "value": 2990 }, { "hour": "1am", "weekday": "Wed", "value": 1890 }, { "hour": "2am", "weekday": "Wed", "value": 1990 }, { "hour": "3am", "weekday": "Wed", "value": 1000 }, { "hour": "4am", "weekday": "Wed", "value": 2100 }, { "hour": "5am", "weekday": "Wed", "value": 2990 }, { "hour": "6am", "weekday": "Wed", "value": 2100 }, { "hour": "7am", "weekday": "Wed", "value": 2990 }, { "hour": "8am", "weekday": "Wed", "value": 1200 }, { "hour": "9am", "weekday": "Wed", "value": 900 }, { "hour": "10am", "weekday": "Wed", "value": 2000 }, { "hour": "11am", "weekday": "Wed", "value": 1100 }, { "hour": "12am", "weekday": "Wed", "value": 2990 }, { "hour": "12pm", "weekday": "Wed", "value": 2990 }, { "hour": "1pm", "weekday": "Thu", "value": 2990 }, { "hour": "2pm", "weekday": "Thu", "value": 1990 }, { "hour": "3pm", "weekday": "Thu", "value": 990 }, { "hour": "4pm", "weekday": "Thu", "value": 2000 }, { "hour": "5pm", "weekday": "Thu", "value": 7890 }, { "hour": "6pm", "weekday": "Thu", "value": 1290 }, { "hour": "7pm", "weekday": "Thu", "value": 1090 }, { "hour": "8pm", "weekday": "Thu", "value": 2990 }, { "hour": "9pm", "weekday": "Thu", "value": 2990 }, { "hour": "10pm", "weekday": "Thu", "value": 2990 }, { "hour": "11pm", "weekday": "Thu", "value": 2990 }, { "hour": "12pm", "weekday": "Thu", "value": 2990 }, { "hour": "1am", "weekday": "Thu", "value": 1890 }, { "hour": "2am", "weekday": "Thu", "value": 1990 }, { "hour": "3am", "weekday": "Thu", "value": 1000 }, { "hour": "4am", "weekday": "Thu", "value": 2100 }, { "hour": "5am", "weekday": "Thu", "value": 2990 }, { "hour": "6am", "weekday": "Thu", "value": 2100 }, { "hour": "7am", "weekday": "Thu", "value": 2990 }, { "hour": "8am", "weekday": "Thu", "value": 1200 }, { "hour": "9am", "weekday": "Thu", "value": 900 }, { "hour": "10am", "weekday": "Thu", "value": 2000 }, { "hour": "11am", "weekday": "Thu", "value": 1100 }, { "hour": "12am", "weekday": "Thu", "value": 2990 }],

            // Device and Operating system
            is_device_loaded: false,
            sunbrustchart: [{ "name": "Mobile", "children": [{ "name": "Android", "value": 100 }, { "name": "IOS", "value": 60 }] }, { "name": "Desktop", "children": [{ "name": "Android", "value": 100 }, { "name": "IOS", "value": 60 }] }, { "name": "Tablet", "children": [{ "name": "Android", "value": 100 }, { "name": "IOS", "value": 160 }] }],


            mention_word_dropdown_option: [{ "value": "", "label": "All" }, { "value": "18-24", "label": "18-24" }, { "value": "25-34", "label": "25-34" }, { "value": "35-44", "label": "35-44" }, { "value": "45-54", "label": "45-54" }, { "value": "55-64", "label": "55-64" }, { "value": "65+", "label": "65+" }],
            is_channel_loaded: false,
            channel_name: "",

            is_nested_table_loaded: false,
            channel_medium_source_metrics: [],

            // --------------- Overall Metrics ----------
            is_overall_metrics_loaded: false,
            // Session Card
            current_session: 0,
            last_session: 0,
            session_growth: 0,
            session_list: [],

            // Users
            current_user: 0,
            last_user: 0,
            user_growth: 0,
            user_list: [],

            // New Users
            current_new_user: 0,
            last_new_user: 0,
            new_user_growth: 0,
            new_user_list: [],

            // Transaction
            current_transaction: 0,
            last_transaction: 0,
            transaction_growth: 0,
            transaction_list: [],

            // Bounce Rate
            current_bounce_rate: 0,
            last_bounce_rate: 0,
            bounce_rate_growth: 0,
            bounce_rate_list: [],

            // ----------------- Earned Metrices ----------------
            is_earned_metrices_loaded: false,
            is_earned_conversion_loaded: false,

            // Earned Impression
            current_earned_impression: 0,
            last_earned_impression: 0,
            earned_impression_growth: 0,
            earned_impression_list: [],

            // Number of keyword
            current_keyword_count: 0,
            last_keyword_count: 0,
            keyword_count_growth: 0,
            keyword_list: [],

            // Earned CTR
            current_earned_ctr: 0,
            last_earned_ctr: 0,
            earned_ctr_growth: 0,
            earned_ctr_list: [],

            // Earned Conversion Rate
            current_conversion_rate: 0,
            last_conversion_rate: 0,
            conversion_rate_growth: 0,
            conversion_rate_list: [],


            // Earned Traffic
            current_earned_traffic: 0,
            last_earned_traffic: 0,
            earned_traffic_list: [],

            // --------------------- Paid Metrices --------------
            is_paid_metrices_loaded: false,
            is_paid_conversion_loaded: false,

            // Paid Traffic
            current_paid_traffic: 0,
            last_paid_traffic: 0,
            paid_traffic_growth: 0,
            paid_traffic_list: [],

            // Paid Impressions
            current_paid_impression: 0,
            last_paid_impression: 0,
            paid_impression_growth: 0,
            paid_impression_list: [],

            // Paid Campaign
            current_paid_campaign: 0,
            last_paid_campaign: 0,
            paid_campaign_growth: 0,
            paid_campaign_list: [],

            // Paid CTR
            current_paid_ctr: 0,
            last_paid_ctr: 0,
            paid_ctr_growth: 0,
            paid_ctr_list: [],

            // Paid Conversion Rate
            current_conversion_rate: 0,
            last_paid_conversion_rate: 0,
            paid_conversion_rate_growth: 0,
            paid_conversion_rate_list: [],

            is_scroll: false,

            first_start_date: props.start_date,
            first_end_date: props.end_date,
            second_start_date: props.previous_start_date,
            second_end_date: props.previous_end_date,
            isDatePickerOpen: false,

            data: '',
            // MapMarker: [ 
            //     {
            //         center: "77.5741697,12.9971791",
            //         north_corner: "0,0",
            //         nsv: 2500,
            //         south_corner: "0,0",
            //         zone: "SOUTH",
            //         zone_id: 3,
            //         city: 'Mumbai'
            //     },
            // ],
            // MapMarker: [
            //     {
            //         zone_id: "6",
            //         center: "75.7885, 23.1765",
            //         north_corner: "23.195342, 75.764998",
            //         south_corner: "23.122721, 75.831854",
            //         city: "UJJAIN",
            //         zone: "WEST",
            //         country: "IN",
            //         nsv: 100,
            //         target_nsv: "1730632.42",
            //         nsv_achieved: "81.74",
            //         ats: "2773.79",
            //         score: "30",
            //         nsv_mix: "0.48"
            //     },
            //     {
            //         zone_id: "11",
            //         center: "88.3953, 26.7271",
            //         north_corner: "88.383707, 26.757838",
            //         south_corner: "88.459336, 26.661382",
            //         city: "SILIGURI",
            //         zone: "EAST",
            //         country: "IN",
            //         nsv: 50,
            //         target_nsv: "3268149.21",
            //         nsv_achieved: "62.48",
            //         ats: "2839.8",
            //         score: "38",
            //         nsv_mix: "0.7"
            //     },
            //     {
            //         zone_id: "45",
            //         center: "77.5946, 12.9716",
            //         north_corner: "77.383346, 13.113602",
            //         south_corner: "77.866436, 12.856547",
            //         city: "BENGALURU",
            //         zone: "SOUTH",
            //         country: "IN",
            //         nsv: 1500,
            //         target_nsv: "43630787.5",
            //         nsv_achieved: "50.11",
            //         ats: "3259.26",
            //         score: "34",
            //         nsv_mix: "7.45"
            //     },
            //     {
            //         zone_id: "28",
            //         center: "75.3704, 11.8745",
            //         north_corner: "75.362395, 11.877311",
            //         south_corner: "75.377931, 11.859084",
            //         city: "KANNUR",
            //         zone: "SOUTH",
            //         country: "IN",
            //         nsv: 60,
            //         target_nsv: "1853703.86",
            //         nsv_achieved: "69.76",
            //         ats: "3093.46",
            //         score: "38",
            //         nsv_mix: "0.44"
            //     },
            //     {
            //         zone_id: "18",
            //         center: "77.2090, 28.6139",
            //         north_corner: "77.116756, 28.668884",
            //         south_corner: "77.310390, 28.535051",
            //         city: "NEW DELHI",
            //         zone: "NORTH",
            //         country: "IN",
            //         nsv: 1700,
            //         target_nsv: "7511633.01",
            //         nsv_achieved: "75.95",
            //         ats: "3338.34",
            //         score: "38",
            //         nsv_mix: "1.94"
            //     },
            //     {
            //         zone_id: "47",
            //         center: "86.9661, 23.6889",
            //         north_corner: "86.895052, 23.709909",
            //         south_corner: "87.042681, 23.680672",
            //         city: "ASANSOL",
            //         zone: "EAST",
            //         country: "IN",
            //         nsv: 70,
            //         target_nsv: "2339635.21",
            //         nsv_achieved: "73.57",
            //         ats: "2719.06",
            //         score: "32",
            //         nsv_mix: "0.59"
            //     },
            //     {
            //         zone_id: "23",
            //         center: "74.8560, 12.9141",
            //         north_corner: "74.796442, 12.977187",
            //         south_corner: "74.901561, 12.882369",
            //         city: "MANGALOORU",
            //         zone: "SOUTH",
            //         country: "IN",
            //         nsv: 80,
            //         target_nsv: "2856870.44",
            //         nsv_achieved: "60.42",
            //         ats: "3002.04",
            //         score: "35",
            //         nsv_mix: "0.59"
            //     },
            //     {
            //         zone_id: "15",
            //         center: "81.6296, 21.2514",
            //         north_corner: "81.601831, 21.312556",
            //         south_corner: "81.698693, 21.191992",
            //         city: "RAIPUR",
            //         zone: "EAST",
            //         country: "IN",
            //         nsv: 100,
            //         target_nsv: "2952877.26",
            //         nsv_achieved: "66.35",
            //         ats: "3009.78",
            //         score: "37",
            //         nsv_mix: "0.67"
            //     },
            //     {
            //         zone_id: "26",
            //         center: "76.6141, 8.8932",
            //         north_corner: "76.539618, 8.931636",
            //         south_corner: "76.645672, 8.882802",
            //         city: "KOLLAM",
            //         zone: "SOUTH",
            //         country: "IN",
            //         nsv: 89,
            //         target_nsv: "2341613.75",
            //         nsv_achieved: "59.1",
            //         ats: "3641.74",
            //         score: "33",
            //         nsv_mix: "0.47"
            //     },
            //     {
            //         zone_id: "51",
            //         center: "81.8463, 25.4358",
            //         north_corner: "81.675046, 25.494603",
            //         south_corner: "81.915343, 25.351352",
            //         city: "ALLAHABAD",
            //         zone: "NORTH",
            //         country: "IN",
            //         nsv: 58,
            //         target_nsv: "3022295.93",
            //         nsv_achieved: "65.05",
            //         ats: "3067.14",
            //         score: "33",
            //         nsv_mix: "0.67"
            //     },
            //     {
            //         zone_id: "46",
            //         center: "75.3433, 19.8762",
            //         north_corner: "75.273956, 19.897848",
            //         south_corner: "75.366653, 19.834238",
            //         city: "AURANGABAD",
            //         zone: "WEST",
            //         country: "IN",
            //         nsv: 2200,
            //         target_nsv: "4014940.71",
            //         nsv_achieved: "78.02",
            //         ats: "2639.03",
            //         score: "40",
            //         nsv_mix: "1.07"
            //     },
            //     {
            //         zone_id: "12",
            //         center: "78.1460, 11.6643",
            //         north_corner: "78.058662, 11.720484",
            //         south_corner: "78.191390, 11.633614",
            //         city: "SALEM",
            //         zone: "SOUTH",
            //         country: "IN",
            //         nsv: 200,
            //         target_nsv: "2108893.45",
            //         nsv_achieved: "62.73",
            //         ats: "3324.06",
            //         score: "35",
            //         nsv_mix: "0.45"
            //     },
            //     {
            //         zone_id: "20",
            //         center: "76.6394, 12.2958",
            //         north_corner: "76.565649, 12.343171",
            //         south_corner: "76.705730, 12.263877",
            //         city: "MYSORE",
            //         zone: "SOUTH",
            //         country: "IN",
            //         nsv: 650,
            //         target_nsv: "3804451.85",
            //         nsv_achieved: "68.44",
            //         ats: "3426.02",
            //         score: "43",
            //         nsv_mix: "0.89"
            //     },
            //     {
            //         zone_id: "31",
            //         center: "79.9864, 23.1815",
            //         north_corner: "79.957957, 23.237089",
            //         south_corner: "80.016090, 23.145237",
            //         city: "JABALPUR",
            //         zone: "WEST",
            //         country: "IN",
            //         nsv: 254,
            //         target_nsv: "3141979.43",
            //         nsv_achieved: "70.57",
            //         ats: "2921.41",
            //         score: "39",
            //         nsv_mix: "0.76"
            //     },
            //     {
            //         zone_id: "40",
            //         center: "85.8830, 20.4625",
            //         north_corner: "85.807000, 20.495431",
            //         south_corner: "85.956908, 20.440966",
            //         city: "CUTTACK",
            //         zone: "EAST",
            //         country: "IN",
            //         nsv: 652,
            //         target_nsv: "3643369.53",
            //         nsv_achieved: "55.96",
            //         ats: "2471.09",
            //         score: "35",
            //         nsv_mix: "0.69"
            //     },
            //     {
            //         zone_id: "19",
            //         center: "73.7898, 19.9975",
            //         north_corner: "73.734126, 20.051916",
            //         south_corner: "73.879701, 19.933164",
            //         city: "NASHIK",
            //         zone: "WEST",
            //         country: "IN",
            //         nsv: 488,
            //         target_nsv: "4194410.3",
            //         nsv_achieved: "57.78",
            //         ats: "2704.89",
            //         score: "41",
            //         nsv_mix: "0.83"
            //     },
            //     {
            //         zone_id: "10",
            //         center: "72.8311, 21.1702",
            //         north_corner: "72.784036, 21.252989",
            //         south_corner: "72.918271, 21.074013",
            //         city: "SURAT",
            //         zone: "WEST",
            //         country: "IN",
            //         nsv: 51,
            //         target_nsv: "5122099.42",
            //         nsv_achieved: "90.61",
            //         ats: "3047.41",
            //         score: "38",
            //         nsv_mix: "1.58"
            //     },
            //     {
            //         zone_id: "3",
            //         center: "83.2185, 17.6868",
            //         north_corner: "83.198247, 17.827434",
            //         south_corner: "83.259265, 17.643648",
            //         city: "VIZAG",
            //         zone: "APTS",
            //         country: "IN",
            //         nsv: 74,
            //         target_nsv: "4030151.51",
            //         nsv_achieved: "44.67",
            //         ats: "3186.55",
            //         score: "34",
            //         nsv_mix: "0.61"
            //     },
            //     {
            //         zone_id: "13",
            //         center: "85.3096, 23.3441",
            //         north_corner: "85.207533, 23.423559",
            //         south_corner: "85.392598, 23.303332",
            //         city: "RANCHI",
            //         zone: "EAST",
            //         country: "IN",
            //         nsv: 89,
            //         target_nsv: "3553411.94",
            //         nsv_achieved: "63.85",
            //         ats: "2479.73",
            //         score: "34",
            //         nsv_mix: "0.77"
            //     },
            //     {
            //         zone_id: "17",
            //         center: "85.1376, 25.5941",
            //         north_corner: "85.020651, 25.637800",
            //         south_corner: "85.260223, 25.562368",
            //         city: "PATNA",
            //         zone: "EAST",
            //         country: "IN",
            //         nsv: 45,
            //         target_nsv: "8030489.59",
            //         nsv_achieved: "66.38",
            //         ats: "2784.91",
            //         score: "40",
            //         nsv_mix: "1.82"
            //     },
            //     {
            //         zone_id: "24",
            //         center: "80.9462, 26.8467",
            //         north_corner: "80.884822, 26.930685",
            //         south_corner: "81.009651, 26.790436",
            //         city: "LUCKNOW",
            //         zone: "NORTH",
            //         country: "IN",
            //         nsv: 65,
            //         target_nsv: "4103352.43",
            //         nsv_achieved: "62.72",
            //         ats: "2821.99",
            //         score: "47",
            //         nsv_mix: "0.88"
            //     },
            //     {
            //         zone_id: "33",
            //         center: "78.4867, 17.3850",
            //         north_corner: "78.192385, 17.571947",
            //         south_corner: "78.626586, 17.310253",
            //         city: "HYDERABAD",
            //         zone: "APTS",
            //         country: "IN",
            //         nsv: 85,
            //         target_nsv: "53171997.89",
            //         nsv_achieved: "55.14",
            //         ats: "3320.21",
            //         score: "40",
            //         nsv_mix: "10"
            //     },
            //     {
            //         zone_id: "2",
            //         center: "76.8173, 30.6425",
            //         north_corner: "76.813230, 30.666165",
            //         south_corner: "76.847219, 30.641946",
            //         city: "ZIRAKHPUR",
            //         zone: "NORTH",
            //         country: "IN",
            //         nsv: 54,
            //         target_nsv: "3885389.23",
            //         nsv_achieved: "71.46",
            //         ats: "2669.63",
            //         score: "40",
            //         nsv_mix: "0.95"
            //     },
            //     {
            //         zone_id: "30",
            //         center: "75.7873, 26.9124",
            //         north_corner: "75.708148, 26.979416",
            //         south_corner: "75.894915, 26.806111",
            //         city: "JAIPUR",
            //         zone: "NORTH",
            //         country: "IN",
            //         nsv: 32,
            //         target_nsv: "4971356.63",
            //         nsv_achieved: "71.95",
            //         ats: "3613.01",
            //         score: "44",
            //         nsv_mix: "1.22"
            //     },
            //     {
            //         zone_id: "35",
            //         center: "91.7362, 26.1445",
            //         north_corner: "91.670300, 26.202198",
            //         south_corner: "91.852747, 26.125305",
            //         city: "GUWAHATI",
            //         zone: "EAST",
            //         country: "IN",
            //         nsv: 35,
            //         target_nsv: "5654936.36",
            //         nsv_achieved: "49.21",
            //         ats: "2833.69",
            //         score: "40",
            //         nsv_mix: "0.95"
            //     },
            //     {
            //         zone_id: "34",
            //         center: "75.1240, 15.3647",
            //         north_corner: "75.047347, 15.402928",
            //         south_corner: "75.176436, 15.333408",
            //         city: "HUBBALI",
            //         zone: "SOUTH",
            //         country: "IN",
            //         nsv: 96,
            //         target_nsv: "3280168.2",
            //         nsv_achieved: "82.89",
            //         ats: "3275.93",
            //         score: "34",
            //         nsv_mix: "0.93"
            //     },
            //     {
            //         zone_id: "49",
            //         center: "74.8723, 31.6340",
            //         north_corner: "74.833038, 31.677069",
            //         south_corner: "74.949553, 31.602938",
            //         city: "AMRITSAR",
            //         zone: "NORTH",
            //         country: "IN",
            //         nsv: 41,
            //         target_nsv: "2547156.82",
            //         nsv_achieved: "68",
            //         ats: "2863.04",
            //         score: "35",
            //         nsv_mix: "0.59"
            //     },
            //     {
            //         zone_id: "48",
            //         center: "72.9289, 22.5645",
            //         north_corner: "72.914521, 22.571379",
            //         south_corner: "72.996575, 22.526354",
            //         city: "ANAND",
            //         zone: "WEST",
            //         country: "IN",
            //         nsv: 63,
            //         target_nsv: "2372595.19",
            //         nsv_achieved: "98.44",
            //         ats: "3424.62",
            //         score: "41",
            //         nsv_mix: "0.8"
            //     },
            //     {
            //         zone_id: "53",
            //         center: "78.0081, 27.1767",
            //         north_corner: "77.883879, 27.240277",
            //         south_corner: "78.080260, 27.148360",
            //         city: "AGRA",
            //         zone: "NORTH",
            //         country: "IN",
            //         nsv: 800,
            //         target_nsv: "2659364.91",
            //         nsv_achieved: "72.59",
            //         ats: "2510.19",
            //         score: "39",
            //         nsv_mix: "0.66"
            //     },
            //     {
            //         zone_id: "43",
            //         center: "69.6669, 23.2420",
            //         north_corner: "69.653375, 23.271233",
            //         south_corner: "69.699567, 23.233568",
            //         city: "BHUJ",
            //         zone: "WEST",
            //         country: "IN",
            //         nsv: 65,
            //         target_nsv: "2093627.87",
            //         nsv_achieved: "61.1",
            //         ats: "2704.6",
            //         score: "30",
            //         nsv_mix: "0.44"
            //     },
            //     {
            //         zone_id: "41",
            //         center: "80.2707, 13.0827",
            //         north_corner: "80.154603, 13.189012",
            //         south_corner: "80.258045, 12.927241",
            //         city: "CHENNAI",
            //         zone: "SOUTH",
            //         country: "IN",
            //         nsv: 3500,
            //         target_nsv: "6935649.17",
            //         nsv_achieved: "52.61",
            //         ats: "3293.44",
            //         score: "31",
            //         nsv_mix: "1.24"
            //     },
            //     {
            //         zone_id: "21",
            //         center: "72.8777, 19.0760",
            //         north_corner: "72.782983, 19.257312",
            //         south_corner: "72.938756, 19.014517",
            //         city: "MUMBAI",
            //         zone: "WEST",
            //         country: "IN",
            //         nsv: 5000,
            //         target_nsv: "49556045.77",
            //         nsv_achieved: "69.59",
            //         ats: "2979.74",
            //         score: "42",
            //         nsv_mix: "11.76"
            //     },
            //     {
            //         zone_id: "27",
            //         center: "88.3639, 22.5726",
            //         north_corner: "88.458589, 22.993330",
            //         south_corner: "88.443637, 22.467182",
            //         city: "KOLKATA",
            //         zone: "EAST",
            //         country: "IN",
            //         nsv: 3200,
            //         target_nsv: "34035547.04",
            //         nsv_achieved: "57.8",
            //         ats: "2959.73",
            //         score: "38",
            //         nsv_mix: "6.71"
            //     },
            //     {
            //         zone_id: "4",
            //         center: "80.6480, 16.5062",
            //         north_corner: "80.568078, 16.553657",
            //         south_corner: "80.718962, 16.474920",
            //         city: "VIJAYAWADA",
            //         zone: "APTS",
            //         country: "IN",
            //         nsv: 100,
            //         target_nsv: "5070190.57",
            //         nsv_achieved: "43.44",
            //         ats: "3646.32",
            //         score: "38",
            //         nsv_mix: "0.75"
            //     },
            //     {
            //         zone_id: "16",
            //         center: "73.8567, 18.5204",
            //         north_corner: "73.753311, 18.580924",
            //         south_corner: "73.956120, 18.451389",
            //         city: "PUNE",
            //         zone: "WEST",
            //         country: "IN",
            //         nsv: 459,
            //         target_nsv: "24103709.13",
            //         nsv_achieved: "59.61",
            //         ats: "2621.27",
            //         score: "36",
            //         nsv_mix: "4.9"
            //     },
            //     {
            //         zone_id: "39",
            //         center: "78.0322, 30.3165",
            //         north_corner: "78.020221, 30.373702",
            //         south_corner: "78.087990, 30.279693",
            //         city: "DEHRADUN",
            //         zone: "NORTH",
            //         country: "IN",
            //         nsv: 120,
            //         target_nsv: "2507966.21",
            //         nsv_achieved: "58.07",
            //         ats: "2537.34",
            //         score: "34",
            //         nsv_mix: "0.5"
            //     },
            //     {
            //         zone_id: "37",
            //         center: "88.6138, 27.3314",
            //         north_corner: "88.593064, 27.375400",
            //         south_corner: "88.618828, 27.323850",
            //         city: "GANGTOK",
            //         zone: "EAST",
            //         country: "IN",
            //         nsv: 96,
            //         target_nsv: "1694536.04",
            //         nsv_achieved: "43.83",
            //         ats: "2652.5",
            //         score: "27",
            //         nsv_mix: "0.25"
            //     },
            //     {
            //         zone_id: "32",
            //         center: "75.8577, 22.7196",
            //         north_corner: "75.798606, 22.792296",
            //         south_corner: "75.920366, 22.657624",
            //         city: "INDORE",
            //         zone: "WEST",
            //         country: "IN",
            //         nsv: 63,
            //         target_nsv: "6988414.86",
            //         nsv_achieved: "63.31",
            //         ats: "3085.46",
            //         score: "36",
            //         nsv_mix: "1.51"
            //     },
            //     {
            //         zone_id: "5",
            //         center: "73.1812, 22.3072",
            //         north_corner: "73.078316, 22.410741",
            //         south_corner: "73.231520, 22.242783",
            //         city: "VADODARA",
            //         zone: "WEST",
            //         country: "IN",
            //         nsv: 60,
            //         target_nsv: "3166495.06",
            //         nsv_achieved: "72.8",
            //         ats: "3260.71",
            //         score: "35",
            //         nsv_mix: "0.79"
            //     },
            //     {
            //         zone_id: "7",
            //         center: "76.9366, 8.5241",
            //         north_corner: "8.564778, 76.842708",
            //         south_corner: "8.466799, 77.003544",
            //         city: "TRIVANDRUM",
            //         zone: "SOUTH",
            //         country: "IN",
            //         nsv: 52,
            //         target_nsv: "3900609.28",
            //         nsv_achieved: "36.98",
            //         ats: "2752.48",
            //         score: "38",
            //         nsv_mix: "0.49"
            //     },
            //     {
            //         zone_id: "1",
            //         center: "80.3319, 26.4499",
            //         north_corner: "80.227820, 26.535600",
            //         south_corner: "80.448685, 26.353820",
            //         city: "KANPUR",
            //         zone: "NORTH",
            //         country: "IN",
            //         nsv: 96,
            //         target_nsv: "2963490.27",
            //         nsv_achieved: "78.16",
            //         ats: "2873.95",
            //         score: "34",
            //         nsv_mix: "0.79"
            //     },
            //     {
            //         zone_id: "14",
            //         center: "70.8022, 22.3039",
            //         north_corner: "70.744732, 22.344620",
            //         south_corner: "70.947718, 22.237121",
            //         city: "RAJKOT",
            //         zone: "WEST",
            //         country: "IN",
            //         nsv: 321,
            //         target_nsv: "2653436.11",
            //         nsv_achieved: "79.46",
            //         ats: "3389.57",
            //         score: "44",
            //         nsv_mix: "0.72"
            //     },
            //     {
            //         zone_id: "29",
            //         center: "74.8570, 32.7266",
            //         north_corner: "74.770143, 32.788333",
            //         south_corner: "74.954159, 32.646993",
            //         city: "JAMMU",
            //         zone: "NORTH",
            //         country: "IN",
            //         nsv: 50,
            //         target_nsv: "1933178.4",
            //         nsv_achieved: "77.97",
            //         ats: "2978.76",
            //         score: "40",
            //         nsv_mix: "0.51"
            //     },
            //     {
            //         zone_id: "50",
            //         center: "77.7523, 20.9320",
            //         north_corner: "80.438601, 16.552839",
            //         south_corner: "80.595014, 16.471199",
            //         city: "AMARAVATI",
            //         zone: "WEST",
            //         country: "IN",
            //         nsv: 102,
            //         target_nsv: "3832564.76",
            //         nsv_achieved: "55.73",
            //         ats: "2836.35",
            //         score: "39",
            //         nsv_mix: "0.73"
            //     },
            //     {
            //         zone_id: "42",
            //         center: "75.7804, 11.2588",
            //         north_corner: "75.735959, 11.337213",
            //         south_corner: "75.881733, 11.199490",
            //         city: "CALICUT",
            //         zone: "SOUTH",
            //         country: "IN",
            //         nsv: 32,
            //         target_nsv: "2760131.55",
            //         nsv_achieved: "52.01",
            //         ats: "2605.56",
            //         score: "34",
            //         nsv_mix: "0.49"
            //     },
            //     {
            //         zone_id: "25",
            //         center: "76.5604, 18.4088",
            //         north_corner: "76.523536, 18.426447",
            //         south_corner: "76.621898, 18.386542",
            //         city: "LATUR",
            //         zone: "WEST",
            //         country: "IN",
            //         nsv: 98,
            //         target_nsv: "2521062.64",
            //         nsv_achieved: "72.11",
            //         ats: "2521.36",
            //         score: "36",
            //         nsv_mix: "0.62"
            //     },
            //     {
            //         zone_id: "8",
            //         center: "79.4192, 13.6288",
            //         north_corner: "79.347320, 13.691059",
            //         south_corner: "79.507372, 13.605190",
            //         city: "TIRUPATI",
            //         zone: "APTS",
            //         country: "IN",
            //         nsv: 85,
            //         target_nsv: "2730102.59",
            //         nsv_achieved: "66.77",
            //         ats: "3369.56",
            //         score: "43",
            //         nsv_mix: "0.62"
            //     },
            //     {
            //         zone_id: "38",
            //         center: "70.1337, 23.0753",
            //         north_corner: "70.114228, 23.100265",
            //         south_corner: "70.146500, 23.040567",
            //         city: "GANDHIDHAM",
            //         zone: "WEST",
            //         country: "IN",
            //         nsv: 40,
            //         target_nsv: "1922015.77",
            //         nsv_achieved: "81.24",
            //         ats: "2642.19",
            //         score: "31",
            //         nsv_mix: "0.53"
            //     },
            //     {
            //         zone_id: "44",
            //         center: "85.8245, 20.2961",
            //         north_corner: "85.795600, 20.374311",
            //         south_corner: "85.880132, 20.264593",
            //         city: "BHUBANESWAR",
            //         zone: "EAST",
            //         country: "IN",
            //         nsv: 200,
            //         target_nsv: "7247113.23",
            //         nsv_achieved: "52.7",
            //         ats: "2924.28",
            //         score: "44",
            //         nsv_mix: "1.3"
            //     },
            //     {
            //         zone_id: "52",
            //         center: "72.5714, 23.0225",
            //         north_corner: "72.498337, 23.111038",
            //         south_corner: "72.670220, 22.958967",
            //         city: "AHMEDABAD",
            //         zone: "WEST",
            //         country: "IN",
            //         nsv: 1300,
            //         target_nsv: "20722987.44",
            //         nsv_achieved: "69.49",
            //         ats: "3131.81",
            //         score: "38",
            //         nsv_mix: "4.91"
            //     },
            //     {
            //         zone_id: "9",
            //         center: "76.2144, 10.5276",
            //         north_corner: "76.175268, 10.581163",
            //         south_corner: "76.276186, 10.458231",
            //         city: "THRISSUR",
            //         zone: "SOUTH",
            //         country: "IN",
            //         nsv: 50,
            //         target_nsv: "3516266.04",
            //         nsv_achieved: "46.47",
            //         ats: "2618.65",
            //         score: "42",
            //         nsv_mix: "0.56"
            //     },
            //     {
            //         zone_id: "36",
            //         center: "77.4538, 28.6692",
            //         north_corner: "77.235935, 28.783836",
            //         south_corner: "77.523366, 28.639887",
            //         city: "GHAZIABAD",
            //         zone: "NORTH",
            //         country: "IN",
            //         nsv: 65,
            //         target_nsv: "7488856.29",
            //         nsv_achieved: "67.18",
            //         ats: "2935.06",
            //         score: "41",
            //         nsv_mix: "1.71"
            //     }
            // ],
            // North_point: [72.6416015625, 37.71859032558816],
            // South_point: [93.1640625, 5.7908968128719565],
            // map_level: 0,
            // center_point: [0, 0],
            is_India_map_loaded: true,
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
            this.setState({
                first_start_date: nextProps.start_date,
                first_end_date: nextProps.end_date,
                second_start_date: nextProps.previous_start_date,
                second_end_date: nextProps.previous_end_date,
            });
        }
    }

    componentDidMount() {
        this.state.is_India_map_loaded = true;

        // this.getMapdetails();
        this.getChannelGroup()
        this.getOverallMetrices()
        this.getEarnedMetrices()
        this.getPaidMetrices()
        this.getEarnedConversionRateMetrices()
        this.getPaidConversionRateMetrices()
        this.getDeviceMetrices()
        this.getDayTimeTrafficMetrices()
        this.getAudienceDemographicMetrices()
        this.getChannelMediumSourceMetrics()

        this.forceUpdate()
        window.addEventListener("scroll", this.handleScroll);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.start_date !== this.props.start_date ||
            prevProps.end_date !== this.props.end_date ||
            prevProps.previous_start_date !== this.props.previous_start_date ||
            prevProps.previous_end_date !== this.props.previous_end_date
        ) {

            this.setState({
                is_channel_loaded: false,
                is_audience_demographic_loaded: false,
                is_paid_metrices_loaded: false,
                is_paid_conversion_loaded: false,
                is_earned_metrices_loaded: false,
                is_earned_conversion_loaded: false,
                is_overall_metrics_loaded: false,
                is_nested_table_loaded: false,
                is_device_loaded: false,
                is_day_time_traffic_loaded: false
            });

            this.getChannelGroup()
            this.getOverallMetrices()
            this.getEarnedMetrices()
            this.getPaidMetrices()
            this.getEarnedConversionRateMetrices()
            this.getPaidConversionRateMetrices()
            this.getDeviceMetrices()
            this.getDayTimeTrafficMetrices()
            this.getAudienceDemographicMetrices()
            this.getChannelMediumSourceMetrics()
        }
    }

    getMapdetails() {
        let result = [];

        let start_date = "2022-01-24";
        let end_date = "2022-01-30";
        //map filter
        let category = '';
        let store_type = '';
        let store_size = '';

        const url = "https://api2.icogz.com/api/ri/zones/";

        fetch(url, {
            method: "POST",
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&city_type=" + category +
                "&store_type=" + store_type +
                "&store_size=" + store_size,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                'Authorization': ' Bearer ' + localStorage.getItem("token")
            },
        })
            .then((res) => res.json())
            .then(
                (result1) => {
                    let varIndiaMapData = result1.data;

                    this.setState({
                        MapMarker: varIndiaMapData,
                        is_India_map_loaded: true
                    });

                },
                (error) => { }
            );
    }


    handleCallback = (childData) => {
        this.state.trafficeChannel = childData;
        this.setState({ daily_metrics_name: childData, is_daily_data_loaded: false });
    }

    handleAgeCallback = (age_bracket) => {
        this.state.age_bracket = age_bracket
        this.setState({ age_bracket: age_bracket, is_audience_demographic_loaded: false });
        this.getAudienceDemographicMetrices()
    }

    handleChannelGroup = (channel_name) => {
        this.state.channel_name = channel_name
        this.state.trafficeChannel = channel_name;
        this.setState({
            channel_name: channel_name,
            is_audience_demographic_loaded: false,
            is_paid_metrices_loaded: false,
            is_paid_conversion_loaded: false,
            is_earned_metrices_loaded: false,
            is_earned_conversion_loaded: false,
            is_overall_metrics_loaded: false,
            is_nested_table_loaded: false,
            is_device_loaded: false,
            is_day_time_traffic_loaded: false
        });

        this.getOverallMetrices()
        this.getOverallMetrices()
        this.getEarnedMetrices()
        this.getPaidMetrices()
        this.getEarnedConversionRateMetrices()
        this.getPaidConversionRateMetrices()
        this.getDeviceMetrices()
        this.getDayTimeTrafficMetrices()
        this.getAudienceDemographicMetrices()
        this.getChannelMediumSourceMetrics()
        // TODO call all apis
    }

    // PIE Chart - Channels
    getChannelGroup() {

        let start_date = this.state.first_start_date;
        let end_date = this.state.first_end_date;
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;

        const url = API_URL + "ecom/channel-group/"
        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': ' Bearer ' + localStorage.getItem("token")
            },
        }).then(res => res.json())
            .then((result) => {
                let channels = result['channels']
                let data = []
                channels.map((info) => {
                    data.push({
                        'name': info['channel_name'],
                        'value': info['total_session']
                    })

                    this.setState({
                        is_channel_loaded: true,
                        trafficpievalue: data,
                    });
                })
            }, (error) => {
            })
    }

    getOverallMetrices() {

        let start_date = this.state.first_start_date;
        let end_date = this.state.first_end_date;
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;
        let channel_name = this.state.channel_name;

        const url = API_URL + "ecom/overall-metrics/"
        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date +
                "&channel_name=" + channel_name,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': ' Bearer ' + localStorage.getItem("token")
            },
        }).then(res => res.json())
            .then((result) => {
                let current_overall_metrics = result['current_overall_metrics']
                let last_overall_metrics = result['last_overall_metrics']
                let overall_metrics_list = result['overall_metrics_list']

                let current_new_users_metrics = result['current_new_users_metrics']
                let last_new_users_metrics = result['last_new_users_metrics']
                let new_users_metrics = result['new_user_metrics_list']

                let current_bounce_rate = parseFloat(current_overall_metrics[0]['total_bounces']) / parseFloat(current_overall_metrics[0]['total_sessions']) * 100
                let last_bounce_rate = parseFloat(last_overall_metrics[0]['total_bounces']) / parseFloat(last_overall_metrics[0]['total_sessions']) * 100
                let session_list = [], new_user_list = [], bounce_list = [], user_list = [], transaction_list = []

                overall_metrics_list.map((info) => {
                    session_list.push({ "date": info['date'], "value": info['total_sessions'] })

                    let b = (parseFloat(info['total_bounces']) / parseFloat(info['total_sessions']) * 100)
                    if (isNaN(b)) { b = 0 }

                    bounce_list.push({ "date": info['date'], "value": b != 0 ? b.toFixed(2) : b })
                    user_list.push({ "date": info['date'], "value": info['total_users'] })
                    transaction_list.push({ "date": info['date'], "value": info['total_transactions'] })
                });

                new_users_metrics.map((info) => {
                    new_user_list.push({ "date": info['date'], "value": info['total_users'] })
                });

                if (isNaN(last_bounce_rate)) { last_bounce_rate = 0 }
                if (isNaN(current_bounce_rate)) { current_bounce_rate = 0 }

                this.setState({
                    current_session: current_overall_metrics[0]['total_sessions'],
                    last_session: last_overall_metrics[0]['total_sessions'],
                    session_list: session_list,

                    // Users
                    current_user: current_overall_metrics[0]['total_users'],
                    last_user: last_overall_metrics[0]['total_users'],
                    user_list: user_list,

                    // New Users
                    current_new_user: current_new_users_metrics[0]['total_users'],
                    last_new_user: last_new_users_metrics[0]['total_users'],
                    new_user_list: new_user_list,

                    // Transaction
                    current_transaction: current_overall_metrics[0]['total_transactions'],
                    last_transaction: last_overall_metrics[0]['total_transactions'],
                    transaction_list: transaction_list,

                    // Bounce Rate
                    current_bounce_rate: current_bounce_rate != 0 ? current_bounce_rate.toFixed(2) : current_bounce_rate,
                    last_bounce_rate: last_bounce_rate != 0 ? last_bounce_rate.toFixed(2) : last_bounce_rate,
                    bounce_rate_list: bounce_list,

                    // Overall metrics flags
                    is_overall_metrics_loaded: true
                })
            }, (error) => {
            })
    }

    getEarnedMetrices() {
        let start_date = this.state.first_start_date;
        let end_date = this.state.first_end_date;
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;
        let channel_name = this.state.channel_name

        const url = API_URL + "ecom/earned-metrics/"
        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date +
                "&channel_name=" + channel_name,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': ' Bearer ' + localStorage.getItem("token")
            },

        }).then(res => res.json())
            .then((result) => {
                let current_earned_metrics = result['current_earned_metrics']
                let last_earned_metrics = result['last_earned_metrics']
                let earned_metrics_list = result['earned_metrics_list']

                let current_keyword_metrics = result['current_keyword_metrics']
                let last_keyword_metrics = result['last_keyword_metrics']
                let keyword_metrics_list = result['keyword_metrics_list']

                let current_ctr = parseFloat(current_earned_metrics[0]['total_clicks']) / parseFloat(current_earned_metrics[0]['total_impressions']) * 100
                let last_ctr = parseFloat(last_earned_metrics[0]['total_clicks']) / parseFloat(last_earned_metrics[0]['total_impressions']) * 100

                if (isNaN(current_ctr)) { current_ctr = 0 }
                if (isNaN(last_ctr)) { last_ctr = 0 }

                let impression_list = [], keyword_list = [], ctr_list = [];

                earned_metrics_list.map((info) => {
                    impression_list.push({ "date": info['date'], "value": info['total_impressions'] })
                    let ctr = (parseFloat(info['total_clicks']) / parseFloat(info['total_impressions']))
                    if (isNaN(ctr)) { ctr = 0 }
                    ctr_list.push({ "date": info['date'], "value": ((ctr) * 100) != 0 ? ((ctr) * 100).toFixed(2) : ctr })
                })

                keyword_metrics_list.map((info) => {
                    keyword_list.push({ "date": info['date'], "value": info['total_key'] })
                })

                this.setState({
                    current_earned_impression: current_earned_metrics[0]['total_impressions'],
                    last_earned_impression: last_earned_metrics[0]['total_impressions'],
                    earned_impression_list: impression_list,

                    // Number of keyword
                    current_keyword_count: current_keyword_metrics[0]['total_key'],
                    last_keyword_count: last_keyword_metrics[0]['total_key'],
                    keyword_list: keyword_list,

                    // Earned CTR
                    current_earned_ctr: current_ctr != 0 ? current_ctr.toFixed(2) : current_ctr,
                    last_earned_ctr: last_ctr != 0 ? last_ctr.toFixed(2) : last_ctr,
                    earned_ctr_list: ctr_list,
                    is_earned_metrices_loaded: true
                })

            }, (error) => {
            })
    }

    getPaidMetrices() {
        let start_date = this.state.first_start_date;
        // let start_date = '2022-01-20';
        let end_date = this.state.first_end_date;
        // let end_date = '2022-01-30';
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;
        let channel_name = this.state.channel_name

        const url = API_URL + "ecom/paid-metrics/"
        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date +
                "&channel_name=" + channel_name,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': ' Bearer ' + localStorage.getItem("token")
            },
        }).then(res => res.json())
            .then((result) => {
                let current_paid_metrics = result['current_paid_metrics']
                let last_paid_metrics = result['last_paid_metrics']
                let paid_metrics_list = result['paid_metrics_list']

                let current_ctr = ((parseFloat(current_paid_metrics[0]['total_click']) / parseFloat(current_paid_metrics[0]['total_impressions'])) * 100)
                let last_ctr = ((parseFloat(last_paid_metrics[0]['total_click']) / parseFloat(last_paid_metrics[0]['total_impressions'])) * 100)

                if (isNaN(current_ctr)) { current_ctr = 0 }
                if (isNaN(last_ctr)) { last_ctr = 0 }

                let ctr_list = [], impression_list = [], campaign_list = []
                paid_metrics_list.map((info) => {
                    ctr_list.push({ "date": info['ad_date'], "value": (parseFloat(info['total_click']) / parseFloat(info['total_impressions'])).toFixed(2) })
                    impression_list.push({ "date": info['ad_date'], "value": info['total_impressions'] })
                    campaign_list.push({ "date": info['ad_date'], "value": info['total_campaign'] })
                })

                this.setState({
                    // Paid Impressions
                    current_paid_impression: current_paid_metrics[0]['total_impressions'],
                    last_paid_impression: last_paid_metrics[0]['total_impressions'],
                    paid_impression_list: impression_list,

                    // Paid Campaign
                    current_paid_campaign: current_paid_metrics[0]['total_campaign'],
                    last_paid_campaign: last_paid_metrics[0]['total_campaign'],
                    paid_campaign_list: campaign_list,

                    // Paid CTR
                    current_paid_ctr: current_ctr != 0 ? current_ctr.toFixed(2) : current_ctr,
                    last_paid_ctr: last_ctr != 0 ? last_ctr.toFixed(2) : last_ctr,
                    paid_ctr_list: ctr_list,
                    is_paid_metrices_loaded: true
                })

            }, (error) => {
            })
    }

    getEarnedConversionRateMetrices() {
        let start_date = this.state.first_start_date;
        let end_date = this.state.first_end_date;
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;
        let channel_name = this.state.channel_name

        const url = API_URL + "ecom/earned-conversion-metrics/"

        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date +
                "&channel_name=" + channel_name,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': ' Bearer ' + localStorage.getItem("token")
            },
        }).then(res => res.json())
            .then((result) => {
                let current_conversion_metrics = result['current_conversion_metrics']
                let last_conversion_metrics = result['last_conversion_metrics']
                let conversion_metrics_list = result['conversion_metrics_list']


                let conversion_rate = (parseFloat(current_conversion_metrics[0]['total_transactions']) / parseFloat(current_conversion_metrics[0]['total_sessions'])) * 100
                let last_conversion_rate = (parseFloat(last_conversion_metrics[0]['total_transactions']) / parseFloat(last_conversion_metrics[0]['total_sessions'])) * 100


                let conversion_list = [], session_list = [];

                conversion_metrics_list.map((info) => {
                    let conversion = (parseFloat(info['total_transactions']) / parseFloat(info['total_sessions'])) * 100
                    if (isNaN(conversion)) {
                        conversion = 0
                    }
                    conversion_list.push({
                        "date": info['date'],
                        "value": conversion != 0 ? conversion.toFixed(2) : conversion
                    })

                    session_list.push({ "date": info['date'], "value": info['total_sessions'] })
                })

                if (isNaN(conversion_rate)) { conversion_rate = 0 }
                if (isNaN(last_conversion_rate)) { last_conversion_rate = 0 }

                this.setState({
                    // Earned Conversion Rate and traffic
                    current_conversion_rate: conversion_rate != 0 ? conversion_rate.toFixed(2) : conversion_rate,
                    last_conversion_rate: last_conversion_rate != 0 ? last_conversion_rate.toFixed(2) : last_conversion_rate,
                    conversion_rate_list: conversion_list,
                    is_earned_conversion_loaded: true,
                    current_earned_traffic: current_conversion_metrics[0]['total_sessions'],
                    last_earned_traffic: last_conversion_metrics[0]['total_sessions'],
                    earned_traffic_list: session_list
                })
            })
    }

    getPaidConversionRateMetrices() {
        let start_date = this.state.first_start_date;
        let end_date = this.state.first_end_date;
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;
        let channel_name = this.state.channel_name

        const url = API_URL + "ecom/paid-conversion-metrics/"
        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date +
                "&channel_name=" + channel_name,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': ' Bearer ' + localStorage.getItem("token")
            },
        }).then(res => res.json())
            .then((result) => {
                let current_conversion_metrics = result['current_conversion_metrics']
                let last_conversion_metrics = result['last_conversion_metrics']
                let conversion_metrics_list = result['conversion_metrics_list']
                let current_conversion_rate = ((parseFloat(current_conversion_metrics[0]['total_transactions']) / parseFloat(current_conversion_metrics[0]['total_sessions'])) * 100)
                let last_conversion_rate = ((parseFloat(last_conversion_metrics[0]['total_transactions']) / parseFloat(last_conversion_metrics[0]['total_sessions'])) * 100)

                let conversion_list = [], session_list = []
                conversion_metrics_list.map((info) => {
                    let conversion = ((parseFloat(info['total_transactions']) / parseFloat(info['total_sessions'])))
                    if (isNaN(conversion)) { conversion = 0 }

                    conversion_list.push({
                        "date": info['date'],
                        "value": conversion != 0 ? (conversion * 100).toFixed(2) : (conversion * 100)
                    })
                    session_list.push({ "date": info['date'], "value": info['total_sessions'] })

                }, (error) => {

                })

                if (isNaN(current_conversion_rate)) { current_conversion_rate = 0 }
                if (isNaN(last_conversion_rate)) { last_conversion_rate = 0 }

                this.setState({
                    current_paid_conversion_rate: current_conversion_rate != 0 ? current_conversion_rate.toFixed(2) : current_conversion_rate,
                    last_paid_conversion_rate: last_conversion_rate != 0 ? last_conversion_rate.toFixed(2) : last_conversion_rate,
                    paid_conversion_rate_list: conversion_list,

                    current_paid_traffic: current_conversion_metrics[0]['total_sessions'],
                    last_paid_traffic: last_conversion_metrics[0]['total_sessions'],
                    paid_traffic_list: session_list,
                    is_paid_conversion_loaded: true
                })
            }, (error) => {
            })
    }

    getDeviceMetrices() {
        let start_date = this.state.first_start_date;
        let end_date = this.state.first_end_date;
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;
        let channel_name = this.state.channel_name

        const url = API_URL + "ecom/device-metrics/"
        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date +
                "&channel_name=" + channel_name,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': ' Bearer ' + localStorage.getItem("token")
            },
        }).then(res => res.json())
            .then((result) => {
                let device_list = result['device_list']

                let devices = []
                device_list.map((info) => {
                    if (!devices.includes(info['device'])) {
                        devices.push(info['device'])
                    }
                })

                let os_list = []
                devices.map((device_type) => {
                    let childrens = []
                    device_list.map((info) => {
                        if (device_type == info['device']) {
                            childrens.push({ "name": info['operating_system'].charAt(0).toUpperCase() + info['operating_system'].slice(1).toLowerCase(), "value": info['total_session'] })
                        }
                    })
                    let d = { "name": device_type.charAt(0).toUpperCase() + device_type.slice(1).toLowerCase(), "children": childrens }
                    os_list.push(d)
                })

                this.setState({ is_device_loaded: true, sunbrustchart: os_list })


            }, (error) => {
            })
    }

    getDayTimeTrafficMetrices() {
        let start_date = this.state.first_start_date;
        let end_date = this.state.first_end_date;
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;
        let channel_name = this.state.channel_name

        const url = API_URL + "ecom/day-time-traffic/"
        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date +
                "&channel_name=" + channel_name,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': ' Bearer ' + localStorage.getItem("token")
            },
        }).then(res => res.json())
            .then((result) => {
                let traffic_list = result['traffic_list']
                let hour_list = []
                traffic_list.map((info) => {
                    hour_list.push({ "hour": info['hour'], "weekday": info['week_day'].trim(), "value": info['total_session'] })
                })

                this.setState({ is_day_time_traffic_loaded: true, bubblechart: hour_list })
            }, (error) => {
            })
    }

    getAudienceDemographicMetrices() {
        let param = {
            'start_date': this.state.first_start_date,
            'end_date': this.state.first_end_date,
            'last_start_date': this.state.second_start_date,
            'last_end_date': this.state.second_end_date,
            'channel_name': this.state.channel_name,
            'age_bracket': this.state.age_bracket
        }

        // let start_date = this.state.first_start_date;
        // // let start_date = '2022-01-20';
        // let end_date = this.state.first_end_date;
        // // let end_date = '2022-01-30';
        // let previous_start_date = this.state.second_start_date;
        // let previous_end_date = this.state.second_end_date;
        // let channel_name = this.state.channel_name;
        // let age_bracket = this.state.age_bracket;

        const url = API_URL + "ecom/audience-demographic/"
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(param),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': ' Bearer ' + localStorage.getItem("token")
            },
        }).then(res => res.json())
            .then((result) => {
                let male_list = result['male_list']
                let female_list = result['female_list']
                let gender_list = result['gender_list']

                let data = []
                gender_list.map((info) => {
                    let gender_info = { country: info['gender'].charAt(0).toUpperCase() + info['gender'].slice(1).toLowerCase(), "units": info['total_session'] }

                    if (info['gender'] == 'male') {
                        let category = []
                        male_list.map((affinity) => {
                            category.push({ "value": affinity['total_session'], "title": affinity['interestaffinitycategory'].charAt(0).toUpperCase() + affinity['interestaffinitycategory'].slice(1).toLowerCase() })
                        })
                        gender_info['pie'] = category
                    } else if (info['gender'] == 'female') {
                        let category = []
                        female_list.map((affinity) => {
                            category.push({ "value": affinity['total_session'], "title": affinity['interestaffinitycategory'].charAt(0).toUpperCase() + affinity['interestaffinitycategory'].slice(1).toLowerCase() })
                        })
                        gender_info['pie'] = category
                    }

                    data.push(gender_info)
                })
                this.setState({ is_audience_demographic_loaded: true, audience_graphic: data })
            }, (error) => {
            })
    }

    getChannelMediumSourceMetrics() {
        let start_date = this.state.first_start_date;
        let end_date = this.state.first_end_date;
        let previous_start_date = this.state.second_start_date;
        let previous_end_date = this.state.second_end_date;
        let channel_name = this.state.channel_name;

        const url = API_URL + "ecom/overall-table-metrics/"
        fetch(url, {
            method: 'POST',
            body: "start_date=" + start_date +
                "&end_date=" + end_date +
                "&last_start_date=" + previous_start_date +
                "&last_end_date=" + previous_end_date +
                "&channel_name=" + channel_name,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': ' Bearer ' + localStorage.getItem("token")
            },
        }).then(res => res.json())
            .then((result) => {
                let channels = result['channel_list']
                // let mediums = result['medium_list']
                // let sources = result['source_list']

                let data = []
                channels.map((channel_info) => {
                    // let medium_list = []

                    /* mediums.map((medium_info) => {
                         if (medium_info['channel_name'] == channel_info['channel_name']) {
                             let source_list = []
                             sources.map((source_info) => {
                                 if (source_info['channel_name'] == channel_info['channel_name'] && source_info['medium'] == medium_info['medium']) {
                                     let a = {
                                         'BounceRate': 0,
                                         'Channel': source_info['source'],
                                         'ConversionRate': 0,
                                         'ReturningUsers': parseInt(source_info['total_users'])-(source_info['total_new_users']),
                                         'Revenue': source_info['total_revenue'],
                                         'Sessions': source_info['total_session'],
                                         'Transactions': source_info['total_transaction'],
                                         'Users': source_info['total_users'],        
                                         'status': 'Single'                            
                                     } 
                                     source_list.push(a)
                                 }
                             })
     
                             let a = {
                                 'BounceRate': 0,
                                 'Channel': medium_info['medium'],
                                 'ConversionRate': 0,
                                 'ReturningUsers': parseInt(medium_info['total_users'])-(medium_info['total_new_users']),
                                 'Revenue': medium_info['total_revenue'],
                                 'Sessions': medium_info['total_session'],
                                 'Transactions': medium_info['total_transaction'],
                                 'Users': medium_info['total_users'],
                                 'status': 'Single',
                                 'children': source_list
                             } 
                             medium_list.push(a)
     
                         }
                     })*/

                    // Final Data Prepare
                    let conversion = ((parseFloat(channel_info['total_transaction']) / parseFloat(channel_info['total_session'])) * 100)
                    let bounce_rate = ((parseFloat(channel_info['total_bounce']) / parseFloat(channel_info['total_session'])) * 100)

                    if (isNaN(bounce_rate) != 0) { bounce_rate = 0 }
                    if (isNaN(conversion) != 0) { conversion = 0 }

                    let info = {
                        'BounceRate': bounce_rate != 0 ? bounce_rate.toFixed(2) + "%" : bounce_rate,
                        'Channel': channel_info['channel_name'],
                        'ConversionRate': conversion != 0 ? conversion.toFixed(2) + "%" : conversion,
                        'ReturningUsers': parseInt(channel_info['total_users']) - (channel_info['total_new_users']),
                        'Revenue': channel_info['total_revenue'],
                        'Sessions': channel_info['total_session'],
                        'Transactions': channel_info['total_transaction'],
                        'Users': channel_info['total_users'],
                        'status': "Single",
                        // 'children': medium_list
                    }

                    data.push(info)
                })
                this.setState({ is_nested_table_loaded: true, channel_medium_source_metrics: data })

            }, (error) => {
            })
    }

    datepickerHandleCallback = (childData) => {
        this.state.first_start_date = childData[0];
        this.state.first_end_date = childData[1];
        this.state.second_start_date = childData[2];
        this.state.second_end_date = childData[3];

        this.forceUpdate();
        this.datepickerHandleCallback2();

        this.setState({
            is_audience_demographic_loaded: false,
            is_paid_metrices_loaded: false,
            is_paid_conversion_loaded: false,
            is_earned_metrices_loaded: false,
            is_earned_conversion_loaded: false,
            is_overall_metrics_loaded: false,
            is_nested_table_loaded: false,
            is_device_loaded: false,
            is_day_time_traffic_loaded: false
        });

        this.getOverallMetrices()
        this.getEarnedMetrices()
        this.getPaidMetrices()
        this.getEarnedConversionRateMetrices()
        this.getPaidConversionRateMetrices()
        this.getDeviceMetrices()
        this.getDayTimeTrafficMetrices()
        this.getAudienceDemographicMetrices()
        this.getChannelMediumSourceMetrics()
    };

    datepickerHandleCallback2 = () => {
        this.setState({ isDatePickerOpen: !this.state.isDatePickerOpen });
    };

    handleScroll = () => {
        if (window.pageYOffset > 1) {
            if (!this.state.is_scroll) {
                this.setState({ is_scroll: true });
            }
        } else {
            if (this.state.is_scroll) {
                this.setState({ is_scroll: false });
            }
        }
    };

    render() {
        const CarouselSettings = {
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            // initialSlide: 0,
            responsive: [

                {
                    breakpoint: 1202,
                    settings: {
                        arrows: true,
                        slidesToShow: 3,
                        slidesToScroll: 0,
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,

                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,

                    }
                }
            ]
        }

        return (
            <Wrapper>
                <div className="grid grid_cols_4 drawer_grid ri_summary_bsImport">
                    <div className="left_drawer col_span_1 fixed-left-grid mapRightWrapper">
                        <div className="icz-rimapsection bg-white">
                            <Col sm={12} className="icz-cardheader p-20 d-flex">
                                <Col className="icz-cardtitle">
                                    <div className="icz-title-wrap p-0">
                                        <div className="text-left">
                                            <h5 className="icz-cardtitle text-start mb-0">Traffic By Channel</h5>
                                        </div>
                                    </div>
                                </Col>
                            </Col>

                            {this.state.is_channel_loaded == true ?
                                <div className="h-100 d-flex justify-content-center align-items-center">
                                    <Piechart parentCallback={this.handleChannelGroup} card_id="icz-traffic-piechart" card_class="icz-leftsectionchart" graph-data={this.state.trafficpievalue} />
                                </div>
                                : <Loader />}
                        </div>
                    </div>
                    <div className="right_side col_span_3 relative-right-grid icz-ridatacontainer">
                        <div className="content">
                            <div className="content_section">
                                <PageHeader pageTitle={"Traffic"} />
                                <div className="page_content">
                                    <div className="grid grid_cols_1 dashboard_home">
                                        {this.state.trafficeChannel === '' ? '' :
                                            <div className="icz-title-wrap d-flex">
                                                <Col sm={12}>
                                                    <div className="icz-row">
                                                        <Col><h5 className="icz-card-title align-items-start">{this.state.trafficeChannel}</h5></Col>
                                                    </div>
                                                </Col>
                                            </div>
                                        }

                                        {this.state.is_overall_metrics_loaded ?
                                            <div className="icz-carouselcontainer">
                                                <Carousel
                                                    Settings={CarouselSettings}
                                                    class={"icz-cardcontainer"}
                                                    SliderCards={[
                                                        <ChartCard
                                                            index="1"
                                                            CardClass="icz-cardwrapper"
                                                            CardIcon={<IconWebsite className="icz-icon" />}
                                                            CardTitle="Sessions"
                                                            RowOneCurrentValue={this.state.current_session}
                                                            RowOnePreviousValue={this.state.last_session}
                                                            RowOneTitle="overall"
                                                            IsNumber={'number'}
                                                            IsStandard={true}
                                                            chart={<Linegraph_sparkline card_id="icz-sessions" card_class="icz-cardchart" graph-data={this.state.session_list} />}
                                                        />,

                                                        <ChartCard
                                                            index="2"
                                                            CardClass="icz-cardwrapper"
                                                            CardIcon={<IconWebsite className="icz-icon" />}
                                                            CardTitle="Users"
                                                            RowOneCurrentValue={this.state.current_user}
                                                            RowOnePreviousValue={this.state.last_user}
                                                            RowOneTitle="overall"
                                                            IsNumber={'number'}
                                                            IsStandard={true}
                                                            chart={<Linegraph_sparkline card_id="icz-users" card_class="icz-cardchart" graph-data={this.state.user_list} />}
                                                        />,

                                                        <ChartCard
                                                            index="3"
                                                            CardClass="icz-cardwrapper"
                                                            CardIcon={<IconWebsite className="icz-icon" />}
                                                            CardTitle="New Users"
                                                            RowOneCurrentValue={this.state.current_new_user}
                                                            RowOnePreviousValue={this.state.last_new_user}
                                                            RowOneTitle="overall"
                                                            IsNumber={'number'}
                                                            IsStandard={true}
                                                            chart={<Linegraph_sparkline card_id="icz-newuser" card_class="icz-cardchart" graph-data={this.state.new_user_list} />}
                                                        />,

                                                        <ChartCard
                                                            index="4"
                                                            CardClass="icz-cardwrapper"
                                                            CardIcon={<IconWebsite className="icz-icon" />}
                                                            CardTitle="Transactions"
                                                            RowOneCurrentValue={this.state.current_transaction}
                                                            RowOnePreviousValue={this.state.last_transaction}
                                                            RowOneTitle="overall"
                                                            IsNumber={'number'}
                                                            IsStandard={true}
                                                            chart={<Linegraph_sparkline card_id="icz-transactions" card_class="icz-cardchart" graph-data={this.state.transaction_list} />}
                                                        />,


                                                        <ChartCard
                                                            index="5"
                                                            CardClass="icz-cardwrapper"
                                                            CardIcon={<IconWebsite className="icz-icon" />}
                                                            CardTitle="Bounce Rate"
                                                            RowOneCurrentValue={this.state.current_bounce_rate}
                                                            RowOnePreviousValue={this.state.last_bounce_rate}
                                                            RowOneTitle="overall"
                                                            IsNumber={'percentage'}
                                                            IsStandard={false}
                                                            chart={<Linegraph_sparkline card_id="icz-bouncerate" isnumber={"decimal_percentage"} card_class="icz-cardchart" graph-data={this.state.bounce_rate_list} />}
                                                        />
                                                    ]}>
                                                </Carousel>
                                            </div>
                                            : <Loader />}


                                        <div className="icz-title-wrap d-flex">
                                            <Col sm={12}>
                                                <div className="icz-row">
                                                    <Col ><h5 className="icz-card-title align-items-start">Earned</h5></Col>
                                                    <Col className="align-items-end text-end"><Link className="icz-link" to='/ecom/earned'>View More</Link></Col>
                                                </div>
                                            </Col>
                                        </div>

                                        <div className="icz-carouselcontainer">
                                            {this.state.is_earned_conversion_loaded && this.state.is_earned_metrices_loaded ?

                                                <Carousel
                                                    Settings={CarouselSettings}
                                                    class={"icz-cardcontainer"}
                                                    SliderCards={[
                                                        <ChartCard
                                                            index="1"
                                                            CardClass="icz-cardwrapper"
                                                            CardIcon={<IconWebsite className="icz-icon" />}
                                                            CardTitle="Earned Traffic"
                                                            RowOneCurrentValue={this.state.current_earned_traffic <= 0 ? 0 : this.state.current_earned_traffic}
                                                            RowOnePreviousValue={this.state.last_earned_traffic <= 0 ? 0 : this.state.last_earned_traffic}
                                                            RowOneTitle="Earned"
                                                            IsNumber={"number"}
                                                            IsStandard={true}
                                                            chart={<Linegraph_sparkline card_id="icz-earned-traffic" card_class="icz-cardchart" graph-data={this.state.earned_traffic_list} />}
                                                        />,

                                                        <ChartCard
                                                            index="2"
                                                            CardClass="icz-cardwrapper"
                                                            CardIcon={<IconWebsite className="icz-icon" />}
                                                            CardTitle="Earned Impressions"
                                                            RowOneCurrentValue={this.state.current_earned_traffic <= 0 ? 0 : this.state.current_earned_impression}
                                                            RowOnePreviousValue={this.state.last_earned_traffic <= 0 ? 0 : this.state.last_earned_impression}
                                                            RowOneTitle="Earned"
                                                            IsNumber={"number"}
                                                            IsStandard={true}
                                                            chart={<Linegraph_sparkline card_id="icz-earned-impressions" card_class="icz-cardchart" graph-data={this.state.earned_impression_list} />}
                                                        />,
                                                        <ChartCard
                                                            index="3"
                                                            CardClass="icz-cardwrapper"
                                                            CardIcon={<IconWebsite className="icz-icon" />}
                                                            CardTitle="Number Of Keywords"
                                                            RowOneCurrentValue={this.state.current_earned_traffic <= 0 ? 0 : this.state.current_keyword_count}
                                                            RowOnePreviousValue={this.state.last_earned_traffic <= 0 ? 0 : this.state.last_keyword_count}
                                                            RowOneTitle="Earned"
                                                            IsNumber={"number"}
                                                            IsStandard={true}
                                                            chart={<Linegraph_sparkline card_id="icz-number-keywords" card_class="icz-cardchart" graph-data={this.state.keyword_list} />}
                                                        />,

                                                        <ChartCard
                                                            index="4"
                                                            CardClass="icz-cardwrapper"
                                                            CardIcon={<IconWebsite className="icz-icon" />}
                                                            CardTitle="Earned Click Through Rate"
                                                            RowOneCurrentValue={this.state.current_earned_traffic <= 0 ? 0 : this.state.current_earned_ctr}
                                                            RowOnePreviousValue={this.state.last_earned_traffic <= 0 ? 0 : this.state.last_earned_ctr}
                                                            RowOneTitle="Earned"
                                                            IsNumber={"percentage"}
                                                            IsStandard={true}
                                                            chart={<Linegraph_sparkline card_id="icz-click-rate" isnumber={"decimal_percentage"} card_class="icz-cardchart" graph-data={this.state.earned_ctr_list} />}
                                                        />,

                                                        <ChartCard
                                                            index="5"
                                                            CardClass="icz-cardwrapper"
                                                            CardIcon={<IconWebsite className="icz-icon" />}
                                                            CardTitle="Conversion Rate"
                                                            RowOneCurrentValue={this.state.current_earned_traffic <= 0 ? 0 : this.state.current_conversion_rate}
                                                            RowOnePreviousValue={this.state.last_earned_traffic <= 0 ? 0 : this.state.last_conversion_rate}
                                                            RowOneTitle="Earned"
                                                            IsNumber={"percentage"}
                                                            IsStandard={true}
                                                            chart={<Linegraph_sparkline card_id="icz-earned-conversion-rate" isnumber={"decimal_percentage"} card_class="icz-cardchart" graph-data={this.state.conversion_rate_list} />}
                                                        />,
                                                    ]}>

                                                </Carousel>
                                                : <Loader />}
                                        </div>

                                        <div className="icz-title-wrap d-flex">
                                            <Col sm={12}>
                                                <div className="icz-row">
                                                    <Col ><h5 className="icz-card-title align-items-start">Paid</h5></Col>
                                                    <Col className="align-items-end text-end"><Link className="icz-link" to='/ecom/paid'>View More</Link></Col>
                                                </div>
                                            </Col>
                                        </div>

                                        <div className="icz-carouselcontainer">
                                            {this.state.is_paid_metrices_loaded && this.state.is_paid_conversion_loaded ?

                                                <Carousel
                                                    Settings={CarouselSettings}
                                                    class={"icz-cardcontainer"}
                                                    SliderCards={[
                                                        <ChartCard
                                                            index="1"
                                                            CardClass="icz-cardwrapper"
                                                            CardIcon={<IconWebsite className="icz-icon" />}
                                                            CardTitle="Paid Traffic"
                                                            RowOneCurrentValue={this.state.current_paid_traffic <= 0 ? 0 : this.state.current_paid_traffic}
                                                            RowOnePreviousValue={this.state.last_paid_traffic <= 0 ? 0 : this.state.last_paid_traffic}
                                                            RowOneTitle="Earned"
                                                            IsNumber={"number"}
                                                            IsStandard={true}
                                                            chart={<Linegraph_sparkline card_id="icz-paidtraffic" card_class="icz-cardchart" graph-data={this.state.paid_traffic_list} />}
                                                        />,

                                                        <ChartCard
                                                            index="2"
                                                            CardClass="icz-cardwrapper"
                                                            CardIcon={<IconWebsite className="icz-icon" />}
                                                            CardTitle="Paid Impressions"
                                                            RowOneCurrentValue={this.state.current_paid_traffic <= 0 ? 0 : this.state.current_paid_impression != 0 ? this.state.current_paid_impression : 0}
                                                            RowOnePreviousValue={this.state.last_paid_traffic <= 0 ? 0 : this.state.last_paid_impression != 0 ? this.state.last_paid_impression : 0}
                                                            RowOneTitle="Earned"
                                                            IsNumber={"number"}
                                                            IsStandard={true}
                                                            chart={<Linegraph_sparkline card_id="icz-paid-impressions" card_class="icz-cardchart"
                                                                graph-data={this.state.paid_traffic_list <= 0 ? 0 :
                                                                    this.state.paid_impression_list != 0 ?
                                                                        this.state.paid_impression_list : 0} />}
                                                        />,

                                                        <ChartCard
                                                            index="3"
                                                            CardClass="icz-cardwrapper"
                                                            CardIcon={<IconWebsite className="icz-icon" />}
                                                            CardTitle="Number Of Campaigns"
                                                            RowOneCurrentValue={this.state.current_paid_traffic <= 0 ? 0 : this.state.current_paid_campaign}
                                                            RowOnePreviousValue={this.state.last_paid_traffic <= 0 ? 0 : this.state.last_paid_campaign}
                                                            RowOneTitle="Earned"
                                                            IsNumber={"number"}
                                                            IsStandard={true}
                                                            chart={<Linegraph_sparkline card_id="icz-paid-campaings" card_class="icz-cardchart" graph-data={this.state.paid_traffic_list <= 0 ? 0 : this.state.paid_campaign_list != 0 ? this.state.paid_campaign_list : 0} />}
                                                        />,

                                                        <ChartCard
                                                            index="4"
                                                            CardClass="icz-cardwrapper"
                                                            CardIcon={<IconWebsite className="icz-icon" />}
                                                            CardTitle="Paid Click Through Rate"
                                                            RowOneCurrentValue={this.state.current_paid_traffic <= 0 ? 0 : this.state.current_paid_ctr}
                                                            RowOnePreviousValue={this.state.last_paid_traffic <= 0 ? 0 : this.state.last_paid_ctr}
                                                            RowOneTitle="Earned"
                                                            IsNumber={"percentage"}
                                                            IsStandard={true}
                                                            chart={<Linegraph_sparkline card_id="icz-paid-click-rate" isnumber={"decimal_percentage"} card_class="icz-cardchart" graph-data={this.state.paid_traffic_list <= 0 ? 0 : this.state.paid_ctr_list != 0 ? this.state.paid_ctr_list : 0} />}
                                                        />,

                                                        <ChartCard
                                                            index="5"
                                                            CardClass="icz-cardwrapper"
                                                            CardIcon={<IconWebsite className="icz-icon" />}
                                                            CardTitle="Conversion Rate"
                                                            RowOneCurrentValue={this.state.current_paid_traffic <= 0 ? 0 : this.state.current_paid_conversion_rate}
                                                            RowOnePreviousValue={this.state.last_paid_traffic <= 0 ? 0 : this.state.last_paid_conversion_rate}
                                                            RowOneTitle="Earned"
                                                            IsNumber={"percentage"}
                                                            IsStandard={true}
                                                            chart={<Linegraph_sparkline card_id="icz-paid-conversions-rate" isnumber={"decimal_percentage"} card_class="icz-cardchart" graph-data={this.state.paid_traffic_list <= 0 ? 0 : this.state.paid_conversion_rate_list != 0 ? this.state.paid_conversion_rate_list : 0} />}
                                                        />,

                                                    ]}>

                                                </Carousel>
                                                : <Loader />}



                                        </div>

                                        <div className="icz-row">

                                            <Col className="icz-sectioncardwrapper" sm={12} lg={12}>
                                                <div className="icz-sectioncard">
                                                    <Col sm={12} className="icz-cardheader justify-content-between">
                                                        <Col lg={8} className="icz-cardtitle">
                                                            Time/Day Of Traffic
                                                        </Col>
                                                        <Col lg={4} className="icz-cardfilter">
                                                            <div className="icz-cardbtnwrapper icz-chartexport">
                                                                <ChartExport
                                                                    ChartId='timeDayOfTraffic'
                                                                    export_data={this.state.bubblechart}
                                                                    downloadName="Time/Day Of Traffic"
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Col>
                                                    <div className="">
                                                        {this.state.is_day_time_traffic_loaded == true ?
                                                            this.state.bubblechart.length === 0 ?
                                                                <NoDataAvailable />
                                                                :
                                                                <div className="">
                                                                    <HeatMap chart_id="timeDayOfTraffic" chart_class="icz-sectionchart" graph-data={this.state.bubblechart} />
                                                                </div>
                                                            : <Loader />}
                                                    </div>
                                                </div>
                                            </Col>

                                        </div>

                                        <div className="grid grid_cols_4 icz-row">
                                            <div className="grid col_span_2 icz-sectioncardwrapper" >
                                                <div className="icz-sectioncard">
                                                    <div className="icz-cardheader justify-content-between">
                                                        <div className="icz-cardtitle">
                                                            Traffic By Device
                                                        </div>
                                                        <div className="icz-cardfilter">
                                                            <div className="icz-cardbtnwrapper icz-chartexport">
                                                                <ChartExport
                                                                    ChartId='trafficByDevice'
                                                                    export_data={this.state.sunbrustchart}
                                                                    downloadName="Traffic By Device"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="">
                                                        {this.state.is_device_loaded === true ?
                                                            <Sunbrust_chart card_id="trafficByDevice" card_class="icz-sectionchart" graph-data={this.state.sunbrustchart} />
                                                            : <Loader />}
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="grid col_span_2 icz-sectioncardwrapper">
                                                <div className="icz-sectioncard">
                                                    <div className="icz-cardheader justify-content-between">
                                                        <div className="icz-cardtitle">
                                                            Traffic By Location
                                                        </div>
                                                        <div className="icz-cardfilter">
                                                            <div className="icz-cardbtnwrapper icz-chartexport">
                                                                <ChartExport
                                                                    ChartId='trafficByLocationMap'
                                                                    export_data={[]}
                                                                    downloadName="Traffic By Location"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div id='trafficByLocationMap' className="icz-sectionchart" >
                                                        {this.state.is_India_map_loaded === true ?
                                                            <ECOMIndiaMap
                                                                isTooltipEnabled={true}
                                                                // data={this.state.MapMarker}
                                                                // North_point={this.state.North_point}
                                                                // South_point={this.state.South_point}
                                                                // Center_point={this.state.center_point}
                                                                // map_level={this.state.map_level}
                                                                chart_class={"ecom-india-map"} />
                                                            : <Loader />}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="icz-row">
                                            <Col className="icz-sectioncardwrapper" sm={12} lg={12}>
                                                <div className="icz-sectioncard">
                                                    <Col sm={12} className="icz-cardheader flex-wrap justify-content-between">
                                                        <Col lg={6} className="icz-cardtitle">
                                                            Sessions by User Demographics
                                                        </Col>
                                                        <Col lg={6} className="icz-cardfilter">
                                                            <DailydataDropdown dropdown_options={this.state.mention_word_dropdown_option} dropdown_placeholder="Age" parentCallback={this.handleAgeCallback} />
                                                            <div className="icz-cardbtnwrapper icz-chartexport">
                                                                <ChartExport
                                                                    ChartId='growth_current_period'
                                                                    export_data={this.state.audience_graphic}
                                                                    downloadName="Sessions by User Demographics"
                                                                />
                                                            </div>
                                                        </Col>

                                                        {/* <Col className="icz-cardfilter">
                                                <DailydataDropdown dropdown_options={this.state.mention_word_dropdown_option} dropdown_placeholder="Age" parentCallback={this.handleAgeCallback} />
                                            </Col>
                                            <Col lg={2} className="icz-cardfilter">
                                                <div className="icz-cardbtnwrapper">
                                                    <ChartExport ChartId='tweets' exportName="Conversion Funnel"
                                                    //export_href={this.state.export_href} downloadName="Conversion- Funnel.csv"
                                                    />
                                                </div>
                                            </Col> */}
                                                    </Col>
                                                    <div className="">
                                                        {this.state.is_audience_demographic_loaded ?
                                                            <BulletPiechart chart_id="growth_current_period" chart_class="animate__animated animate__fadeInUp animate__slow icz-sectionchart" graph-data1={this.state.audience_graphic} graph-data2={this.state.currentgrowthpiedata} metric_1={"Like"} metric_2={"Dislike"} />
                                                            : <Loader />}
                                                    </div>
                                                </div>
                                            </Col>

                                        </div>

                                        <div className="icz-row d-none">
                                            {this.state.is_table_data_loaded == true ?
                                                <Col className="icz-sectioncardwrapper" sm={12} lg={12}>
                                                    <div className="icz-sectioncard">
                                                        <div className="icz-cardheader">
                                                        </div>
                                                        <div className="icz-table">
                                                            <DataTable Headers={this.state.table_events} TableSize={5} TableData={this.state.table_events_data} className="MainDiv icz-table" />
                                                        </div>
                                                    </div>
                                                </Col>
                                                : <Loader />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </Wrapper>
        )
    }
}

function ReduxStateToProps(state) {
    return {
        start_date: state.date.startDate,
        end_date: state.date.endDate,
        previous_start_date: state.date.prevStartDate,
        previous_end_date: state.date.prevEndDate,
    };
}

export default connect(ReduxStateToProps)(Traffic)